import moment from 'moment'
import actions from './actions'

const initialState = {
  loading: false,
  updating: false,
  removing: false,
  uploading: false,
  reservationSetupDetails: null,
  reservationHours: null,
  blockDates: null,
  depositSettings: null,
  businessDetails: null,
  paymentMode: null,
  savingHour: null,
  removeHour: null,
  removingHour: null,
  hideaddbutton: false,
  data: null,
  data1: null,
  data2: null,
  preview_url: null,
  reservation_interval: null,
  minimum_time_to_book: null,
  maximum_time_to_book: null,
  meal_duration: null,
  is_restaurant_message: null,
  restaurant_message: null,
  theme_color: '',
  background_image: '',
  background_image_url: null,
  addopeninghrs: null,
  editopeninghrs: null,
  actiontype: null,
  creating: false,
  endhourtime: null,
  canDisplayOpeningHourForm: false,
  isSubmittingOpeningHour: false,
  displayPromotionUrlModal: false,
  form_name: null,
  selectedData: null,
  displayAddDrawer: false,
  displayRemoveModal: false,
  errors: {
    create: null,
    update: null,
  },
  slots: null,
  firstForm: false,
  singInPopUp: false,
  otpPopUp: false,
  profilePopUp: false,
  reservationPopUp: false,
  successPage: false,
  phone_number: null,
  customer_device_id: null,
  first_name: null,
  email: null,
  customer_id: null,
  accessToken: null,
  covers: 1,
  date: moment(),
  time: null,
  dietary_instructions: [],
  resendSMS: true,
  reservationSlots: null,
  isPopup: false,
  countryCode: undefined,
}

export default function reservationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_ERROR_STATE:
      return { ...state, errors: { ...state.errors, ...action.payload } }
    default:
      return state
  }
}
